import api from "./api";

export async function fetchQuizQuestions(params = {}) {
  const response = await api.get("/quiz/questions-details", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchQuizQuestionNumberList(params = {}) {
  const response = await api.get("/quiz/questions-number-list", {
    params,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function saveQuizQuestionAnswer(payload = {}) {
  const response = await api.post("/quiz/question-answer-save", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function storeQuizQuestionTime(payload = {}) {
  const response = await api.post("/quiz/store-time", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function saveQuizGuessAnswer(payload = {}) {
  const response = await api.post("/quiz/answer-guess", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function submitQuiz(payload = {}) {
  const response = await api.get("/quiz/quiz-submission", {
    params: payload,
  });

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function saveQuizAssessmentSubmitStatus(payload = {}) {
  const response = await api.post("/quiz/save-assessment-submit-status", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function toggleQuizPause(payload = {}) {
  const response = await api.post("/quiz/toggle-quiz-pause", payload);

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}
